import type { Airport as AirportProps } from "@airhelp/react-ui-components";

export const airportsListMock: AirportProps[] = [
  {
    name: "J. Paul II International Airport Krakow-Balice",
    iata: "KRK",
    city: "Krakow",
    country: "Poland",
    countryCode: "PL",
    rank: 50,
  },
  {
    name: "Pashkovskiy Airport",
    iata: "KRR",
    city: "Krasnodar",
    country: "Russian Federation",
    countryCode: "RU",
    rank: 50,
  },
  {
    name: "Krasnojarsk Airport",
    iata: "KJA",
    city: "Krasnojarsk",
    country: "Russian Federation",
    countryCode: "RU",
    rank: 50,
  },
  {
    name: "Krabi Airport",
    iata: "KBV",
    city: "Krabi",
    country: "Thailand",
    countryCode: "TH",
    rank: 50,
  },
  {
    name: "Krakor",
    iata: "KZD",
    city: "Krakor",
    country: "Kambodia",
    countryCode: "KH",
    rank: 50,
  },
];
